import React from 'react';
import { twJoin } from 'tailwind-merge';

import Icon from 'molecules/Icon';
import Image from 'molecules/Image';
import Link from 'molecules/Link';

import { closeMenu } from 'layout/header/store';
import { miniCallOutStyle } from 'layout/header/styles';

import type { FC } from 'react';

const MiniCallOutCard: FC<HeaderMiniCallOutCard & { context?: 'inside' | 'standalone' }> = ({
  heading,
  description,
  button,
  link,
  featuredImage,
  context = 'standalone',
}) => {
  const isInside = context === 'inside';

  const arrowIcon = <Icon icon="arrow-up-right" size={20} className="shrink-0" />;

  const cardContent = (
    <>
      {featuredImage?.url && (
        <Image
          url={featuredImage.url}
          alt={featuredImage.alt || heading}
          width={isInside ? 65 : 279}
          height={isInside ? 84 : 104}
          className={twJoin('overflow-hidden', isInside ? 'h-[84px] w-[65px] shrink-0' : 'w-full rounded-lg')}
          objectCover
          unsetMaxW
        />
      )}
      {(heading || description) && (
        <div className={twJoin('flex flex-col gap-2', isInside && 'min-w-0 flex-1')}>
          <span className="inline-flex items-center gap-2 font-spaceGrotesk text-lg font-semibold leading-6 text-white transition-colors group-hover:text-primary-100">
            {heading}
            {link && <span className={twJoin('inline-flex', isInside && 'hidden')}>{arrowIcon}</span>}
          </span>

          {description && (
            <span
              className={`text-sm leading-5 text-gray-300 transition-colors group-hover:text-primary-100 ${
                context === 'standalone' ? 'line-clamp-2' : ''
              }`}
            >
              {description}
            </span>
          )}
        </div>
      )}
      {isInside && link && (
        <span className="absolute right-3 top-3 text-white transition-colors group-hover:text-primary-100">
          {arrowIcon}
        </span>
      )}
    </>
  );

  const cardUrl = link || button?.link;

  if (cardUrl) {
    return (
      <Link
        href={cardUrl}
        onClick={() => closeMenu()}
        className={miniCallOutStyle({ context, hasFeaturedImage: !!featuredImage })}
        enablePreview={false}
      >
        {cardContent}
      </Link>
    );
  }

  return <div className={miniCallOutStyle({ context, hasFeaturedImage: !!featuredImage })}>{cardContent}</div>;
};

export default MiniCallOutCard;
